import React, { useState } from 'react'
import { mix_hexes } from '../../../../helpers'
import { Theme } from '@material-ui/core'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

interface Props {
    color: string
    size: number
    left?: number
    right?: number
    direction: 'left' | 'right'
    onClick: () => void
    className?: string
    theme: Theme
    ariaLabel: string
}

export const DragIcon = (props: Props) => {
    const size = props.size
    const [isHovered, setIsHovered] = useState(false)

    const color = mix_hexes(props.color, '#ffffff')
    const hoverColor = mix_hexes(props.color, '#d8e9ff')
    const Icon = props.direction === 'left' ? ChevronLeftIcon : ChevronRightIcon

    return (
        <button
            type="button"
            className={props.className}
            aria-label={props.ariaLabel}
            style={{
                height: size,
                width: size,
                padding: 0,
                backgroundColor: isHovered ? hoverColor : color,
                zIndex: 1,
                position: 'absolute',
                top: `calc(50% - ${size / 2}px)`,
                left: props.left,
                right: props.right,
                borderRadius: props.theme.shape.borderRadius,
                border: 0,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 100ms ease-in-out',
            }}
            onClick={props.onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Icon style={{ fontSize: size * 0.9 }} />
        </button>
    )
}
